import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

export function Store(){
	
	const [ loading, setLoading ] = useState(true);
	const [ data, setData ] = useState([]);
	
	let { id } = useParams()
	
	const mailaddress = useSelector(state => state.usermangement.mailaddress);
	const password = useSelector(state => state.usermangement.password);
	
	useEffect(() => {
		
		const toastid = toast.loading('Loading data ...');
		
		var myHeaders = new Headers();
		myHeaders.append('Authorization', 'Basic ' + btoa(mailaddress + ":" + password));

		var requestOptions = {
			method: 'GET',
			headers: myHeaders,
			redirect: 'follow'
		};
		
		fetch(window._env_.URL + "/api/v1/store/" + id, requestOptions)
			.then(response => response.text())
			.then((result) => {
				
				setData(JSON.parse(result));
				
				setLoading(false);
				
				toast.update(toastid, { render: "Data loaded", type: "success", isLoading: false, autoClose: 5000 })
				
			})
			.catch((err) => { 
				
				console.log(err)
				
				setLoading(false);
				
				toast.update(toastid, { render: err, type: "error", isLoading: false, autoClose: 5000 });
				
			})
		
	}, [mailaddress, password, id])
	
	return(
		<>
			{ loading &&
				<p>Lade Daten ...</p>
			}
			{ !loading &&
				<>
					<h1>{data.name}</h1>
					<p>Unternehmen: {data.companyName}</p>
					<p>Organisations: {data.corporationName}</p>
					<p><Link to={"/" + id + "/housebanlist"}>Hausverbotsliste</Link></p>
				</>
			}
		</>
	);
	
}